module.exports = "<select class=\"form-control search-on-change\" [(ngModel)]=\"value\" >\r\n    <option [ngValue]=\"undefined\" *ngIf=\"inputValue === undefined\">Please select...</option>\r\n    <option *ngFor=\"let value of boolValues\" [ngValue]=\"value.value\">{{value.display}}</option>\r\n</select>";


//////////////////
// WEBPACK FOOTER
// ./Client/app/components/common/tristatedropdown/tristate.dropdown.component.html
// module id = 1275
// module chunks = 0